import { tss } from "tss-react/mui";
import { DEFAULT_LEFT_PADDING, DEFAULT_RIGHT_PADDING, MOBILE_LEFT_PADDING, MOBILE_RIGHT_PADDING, WINDOW_MAX_WIDTH } from "../../../layout/Layout.styles";

export const useStyles = tss.create(({ theme }) => ({
	root: {
		[theme.breakpoints.down('md')]: {
			backgroundColor: '#F9F9FB',
		}
	},
	container: {
		color: 'white',
		margin: '0 auto',
		maxWidth: WINDOW_MAX_WIDTH,
		paddingLeft: DEFAULT_LEFT_PADDING,
		paddingRight: DEFAULT_RIGHT_PADDING,
		paddingBottom: 48,
		paddingTop: 68,
		position: 'relative',
		overflow: 'hidden',
		'& > div': {
			textAlign: 'center',
		},
		[theme.breakpoints.down('md')]: {
			paddingLeft: MOBILE_LEFT_PADDING,
			paddingRight: MOBILE_RIGHT_PADDING,
			paddingBottom: 40,
			paddingTop: 35,
		}
	},
	subContainer: {
		backgroundColor: theme.palette.primary.main,
		borderRadius: 8,
		boxShadow: '0px 3px 20px #EDEDF0',
		color: 'inherit',
		padding: '76px 0px 48px',
		[theme.breakpoints.down('md')]: {
			backgroundColor: 'white',
			padding: '44px 24px 31px',
		}
	},
	title: {
		color: 'inherit',
		fontSize: 22,
		fontWeight: 700,
		lineHeight: '31px',
		marginBottom: 16,
		textAlign: 'center',
		[theme.breakpoints.down('md')]: {
			color: theme.palette.tertiary.main,
			fontSize: 20,
			marginBottom: 24,
		}
	},
	description: {
		color: 'inherit',
		fontSize: 18,
		fontWeight: 400,
		lineHeight: '22px',
		marginBottom: 24,
		textAlign: 'center',
		[theme.breakpoints.down('md')]: {
			color: theme.palette.tertiary.main,
			fontSize: 16,
			lineHeight: '19px',
		}
	},
	emailInput: {
		boxShadow: 'none',
		height: 56,
		marginBottom: 32,
		maxWidth: '100%',
		width: 531,
		'& div:first-child': {
			backgroundColor: 'white',
			border: '1px solid #858585',
		},
		[theme.breakpoints.down('md')]: {
			marginBottom: 24,
			width: 279,
		},
	},
	suscribeButton: {
		color: theme.palette.primary.main,
		backgroundColor: 'white',
		fontWeight: 700,
		height: 52,
		width: 279,
		[theme.breakpoints.down('md')]: {
			color: 'white',
			backgroundColor: theme.palette.primary.main,
		},
		[theme.breakpoints.up('lg')]: {
			'&:hover': {
				backgroundColor: '#e7e7e7 !important',
			},
		}
	},
	emailImageContainer: {
		left: 0,
		textAlign: 'center',
		top: 5,
		position: 'absolute',
		width: '100%',
		'& img': {
			margin: '0 auto'
		},
		'& img.mobile': {
			display: 'none',
		},
		[theme.breakpoints.down('md')]: {
			top: 2,
			'& img.mobile': {
				display: 'block'
			},
			'& img.desktop': {
				display: 'none'
			}
		},
	},
	socialIconsContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		'& a + a': {
			marginLeft: 33,
			[theme.breakpoints.down('md')]: {
				marginLeft: 28,
			}
		},
		'& img': {
			display: 'block',
		},
		'& a': {
			'&.mobile': {
				display: 'none',
			},
			[theme.breakpoints.down('md')]: {
				'&.mobile': {
					display: 'block'
				},
				'&.desktop': {
					display: 'none',
				}
			}
		}
	},
}))